import { BasicInput } from './'

class Text extends BasicInput {}

export default Text